<div class="forecast-wrapper">
    <div *ngIf="!swellData_; else elseBlock">{{noSwellData}}.</div>
    <ng-template #elseBlock>
        <div class="desc-wrapper">
            <span class="text1">{{ null != swellHeight ? swellHeight + "m" : ""}}</span>
        </div>
        <div class="desc-wrapper">
            <span class="text2">{{swellDirection ? (swellDirection | uppercase) : ''}}</span>
        </div>
    </ng-template>
</div>

